module.exports = __webpack_public_path__ + "img/ic_seat.aff7b848.svg";